/*
 * Yoy save text discount update value
 * Implemented: sections/main-product.liquid and assets/custom-async.js.liquid 4430
 */
function initYouSaveDiscount(){

  const productData = document.querySelector("script#product-bagde-data").innerHTML;  

  if(!productData){
    return console.log("You save discount text, Can not found product data script")
  }

  const parsedData = JSON.parse(productData)
 const filteredProducts = parsedData.variants.filter(v => ((v.compare_price !== 0) && (v.price !== v.compare_price)) )
  //console.log("filteredProducts", filteredProducts)
  //console.log("parse data", JSON.parse(productData))

  if(filteredProducts.length === 0){
   return console.log("You save discount text, no products with discount")
  }
  
  const discountProductTitles = filteredProducts.map(v => v.options[0])
  
  if(discountProductTitles.length === 0){
   return console.log("You save discount text, no products sale title")
  }

  const titles =  [...new Set(discountProductTitles)]
  
  if(titles.length === 0){
   return console.log("You save discount text, no products sale unique title")
  }

  //console.log("titles", titles)

  // get curent variant 
  const currentVariant = document.querySelector(".selected-color__value")

  if(!currentVariant){
    return console.log("You save discount text, no current variant")
  }

  const currentVariantColor = currentVariant.dataset.color

  if(!currentVariantColor){
    return console.log("You save discount text, no current variant color")
  }
  
  console.log("You save discount text variant", currentVariantColor)

  // validate if variant is on titles
  const isProductWithDiscount = titles.includes(currentVariantColor)

  // Case #1, first render you save exists + onChange variant without discount
  if(!isProductWithDiscount){
     const youSaveContainer = document.querySelector("[data-js-you-save-container]")
     youSaveContainer?.classList?.add("hide-el")
     return console.log("You save discount text, product WITHOUT discount:", currentVariantColor)
  }
  
  //console.log("isProductWithDiscount", isProductWithDiscount)
  
  // if is on titles get json data
  const filteredDiscountProduct = filteredProducts.filter(p => p.options[0] === currentVariantColor)

  if(filteredDiscountProduct.length === 0){
   return console.log("You save discount text, no products filteredDiscountProduct")
  }
  //console.log("filteredDiscountProduct", filteredDiscountProduct)

  const data = filteredDiscountProduct[0]
  //console.log("discount prod data", data)

  // compare value
   let discountAmount = ((data?.price ?? 0) - (data?.compare_price ?? 0))

  // condition for negative results  variant = 33871797125260
  if(data.compare_price > data.price){
    discountAmount = ((data?.compare_price ?? 0) - (data?.price ?? 0))
  }

  if(discountAmount < 0){
    return console.log("You save discount text, discount amount less:", discountAmount)
  }
  console.log("discountAmount", discountAmount)

  // udapte only for $ currency
  if(Shopify.currency.active !== 'USD'){
     return console.log("You save discount text, discount amount not available for:", Shopify?.currency?.active)
  }

  //console.log("format", formatMoney(discountAmount))

  // create you save text
  const youSaveContainer = document.querySelector("[data-js-you-save-container]")
  const youSaveText = document.createElement("span")
  youSaveText.innerHTML = `You save: <span data-js-you-save>${formatMoney(discountAmount)}</span>`;
  
  if(!youSaveContainer){
     return console.log("You save discount text, DOM node can not be found")
  }
  
  // update dom
  // case #2.1, first render you save did not exists + onChange WITH you save text product + prevent addiing the same node
  if(!document.querySelector("[data-js-you-save]")){  
    youSaveContainer.appendChild(youSaveText)
  }else{
    const a = document.querySelector("[data-js-you-save]")
    if(!a){
     return ("You save discount text #2.1, DOM node can not be found")  
    }
    a.innerHTML = `${formatMoney(discountAmount)}`
  }

  // case #2, first render you save did not exists + onChange WITH you save text product
  youSaveContainer.classList.remove("hide-el")


}
// first load
initYouSaveDiscount()

// variant onChange
// implemented -> assets/custom-async.js.liquid 4430
window.initYouSaveDiscount = initYouSaveDiscount


function formatMoney(price, currencyCode = "USD") {
  const formattedPrice = (price / 100).toFixed(2);
  return ` ${formattedPrice}`;
}

